<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header">
            <div slot="header"><i class="icon-layers"></i> Office Modules</div>
            <div class="sticky-toolbar">
							<div class="d-flex flex-row mb-5">
								<div class="col-2">
									Select Office
								</div>
								<div class="col-6">
									<multiselect @input="fetchVersionModuleData()" v-model="value"
															 :options="officeList"
															 :close-on-select="false"
															 :searchable="true"
															 label = "name"
															 placeholder="Pick a value"></multiselect>
								</div>
							</div>
							<div class="d-flex flex-row-reverse mb-2">
								<div class="col-md-2">
									<b-button variant="primary" class="float-right" size="md" @click="saveConfiguration"><i
										class="fa fa-save"></i> Save
									</b-button>
								</div>
							</div>
						</div>
						<div class="d-flex flex-row mb-2" v-if="moduleList.length >0">
							<div class="col-md-4 pl-0">
								<input type="text" class="form-control" v-model="searchCode" placeholder="Search by code">
							</div>
						</div>
						<div class="table-scroll-wrapper" v-if="moduleList.length >0">
							<table class="table table-hover table-striped table-bordered table-small table-fixed">
								<thead>
								<tr>
									<th class="text-center">Code</th>
									<th class="text-left">Description</th>
									<th class="text-center">Selected</th>
									<th class="text-center">Included</th>
								</tr>
								</thead>
								<tbody>
									<tr v-for="module in filteredModuleList" :key="module.code" class="text-center">
										<td>{{module.code}}</td>
										<td class="text-left">{{module.description}}</td>
										<td>
											<input type="checkbox" :id="module.code" v-model="module.selected">
										</td>
										<td>{{module.includedInVersion ? 'Yes' : 'No'}}</td>
									</tr>
								</tbody>
							</table>
						</div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import officeService from '@/services/officeService'
import toastService from '@/services/toastService'

export default {
  name: 'modules',
	components:{Multiselect},
	data() {
  	return{
  		value:"",
			officeList :[],
			moduleList : [],
			searchCode : "",
		}
	},
	computed:{
		filteredModuleList(){
			if(!this.searchCode) return this.moduleList;
			const search = this.searchCode.toLowerCase();
			return this.moduleList.filter(m => m.code.toLowerCase().includes(search));
		}
	},
	methods:{
  	fetchVersionModuleData(){
  		officeService.getModuleListForOffice(this.value.id,r => {
  			this.moduleList = r.map(item => ({...item, originalSelected: item.selected}))
			}, e => toastService.showErrorToast(e));
		},
		saveConfiguration(){
			const changedModules = this.moduleList
				.filter(m => m.selected !== m.originalSelected)
				.map(m => {
					const { originalSelected, ...rest } = m;
					return rest;
				});

			if (changedModules.length === 0) {
				toastService.showErrorToast("No changes to save");
				return;
			}

  		let request = {
  			modules : changedModules
			};
			officeService.updateModuleListForOffice(this.value.id,request,
				r => {
					this.fetchVersionModuleData()
					toastService.showSuccessToast("Update Successful")
				},
				e => toastService.showErrorToast(e))
		}
	},
	mounted(){
  	officeService.getOfficeList(r => this.officeList = r , e => toastService.showErrorToast(e))
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.sticky-toolbar {
	position: sticky;
	top: 55px;
	z-index: 100;
	background: #fff;
	padding-top: 5px;
}

.table-scroll-wrapper {
	max-height: 60vh;
	overflow-y: auto;
}

/* border-collapse: collapse (bootstrap default) hides the top/bottom
   border of sticky <th> cells once they're stuck mid-scroll in
   Chrome/Firefox; separate + explicit borders avoids the bug. */
.table-scroll-wrapper table {
	border-collapse: separate;
	border-spacing: 0;
}

.table-scroll-wrapper table thead th {
	position: sticky;
	top: 0;
	z-index: 10;
	background: #fff;
	border-top: 1px solid #dee2e6;
	border-bottom: 1px solid #dee2e6;
}
</style>
